import type { MutableRefObject } from 'react'
import { createRef, useState, useLayoutEffect } from 'react'

/* eslint-disable-next-line import/no-restricted-paths -- FIXME: UXP-4500 */
import useSize from '@src/lib/hooks/useSize'

const EMPTY_REF = createRef<HTMLElement>()

export default function useTriggerWidth({
  ref,
  enabled,
}: {
  ref: MutableRefObject<HTMLElement | null>
  enabled: boolean
}) {
  const [resizedWidth, setResizedWidth] = useState(0)

  // Get initial width synchronously to avoid 0px width flash
  useLayoutEffect(() => {
    if (enabled && ref.current) {
      const initialWidth = ref.current.getBoundingClientRect().width
      if (initialWidth > 0) {
        setResizedWidth(initialWidth)
      }
    }
  }, [enabled, ref])

  useSize({
    // give a null ref so the hook doesn't run unnecessarily
    ref: enabled ? ref : EMPTY_REF,
    onResize: (size) => setResizedWidth(size.width),
  })

  return enabled ? (resizedWidth > 0 ? resizedWidth : null) : null
}
